export default __webpack_public_path__ + "static/media/tel3pecom.6ec68270.png";